import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ICheckBehavior, PatientProfileCheckKinds } from "../../../../documaker/domain/format/objects";

export interface ICheckBehaviorPropertyEditable {
  checkBehavior(): IPropertyEditable<ICheckBehavior>;
  isPatientProfileCheckKindSelectable(): boolean;
  getSelectablePatientProfileCheckKinds(): PatientProfileCheckKinds[];
  isGroupScopeSelectable(): boolean;
}

export function instanceOfICheckBehaviorPropertyEditable(instance: any): instance is ICheckBehaviorPropertyEditable {
  return instance
      && instance.checkBehavior
      && instance.isPatientProfileCheckKindSelectable
      && instance.getSelectablePatientProfileCheckKinds
      && instanceOfIPropertyEditable<ICheckBehavior>(instance.checkBehavior());
}
